<!--
 * @Author: zhaoyang
 * @Date: 2024-02-25 15:47:38
 * @Last Modified by: zhaoyang
 * @Last Modified time: 2024-02-29 18:18:05
-->

<template>
    <div
        v-if="finance.bought"
        class="container hold"
    >
        <div class="title">
            保有フアンド
        </div>
        <div class="box">
            <div class="box-title">
                匿名組合契約型
            </div>
            <div class="title1">
                インドネシア・マイクロファイナンス第1号（匿名組合契約型）
            </div>
            <div class="title2">
                目標利回り：７％／年
            </div>
            <div class="title2">
                運用期間：１８０日
            </div>
            <div class="title2">
                ファンド名：インドネシア・マイクロファイナンス第1号（匿名組合契約型）
            </div>

            <div class="pdf-wrap">
                <div
                    v-for="(item,idx) in pdfList"
                    :key="idx"
                    class="pdf-item"
                    @click="handleRead(item)"
                >
                    <img
                        class="pdf-icon"
                        src="./img/pdf.svg"
                        alt=""
                    >
                    <div class="pdf-title">
                        {{ pdfDisplayNameMap[item] }}.pdf
                    </div>
                </div>
            </div>

            <div class="info">
                <div class="info-item">
                    <div class="info-title">
                        324,600万ルピア(※1)
                    </div>
                    <div class="info-desc">
                        贷付残高(202X年8月31日)
                    </div>
                </div>
                <div class="info-item">
                    <div class="info-title">
                        312,500万ルピア(※2)
                    </div>
                    <div class="info-desc">
                        事業開始時(202X年5月31日)
                    </div>
                </div>
            </div>

            <div class="sub-info">
                (※202X年8月31日時点の金額であリ将来変動します)
            </div>

            <div class="sub-info">
                (※2出資金3,000万円(@0.0096))
            </div>
        </div>
    </div>
    <i-empty v-else />
</template>

<script>
import {mapState} from 'vuex';

import {pdfDisplayNameMap} from 'instacash/common/constant';

export default {
    name: 'ProductHold',

    data() {
        return {
            pdfDisplayNameMap,
            pdfList: [
                'contract-before',
                'anonymous',
                'contract'
            ]
        };
    },

    computed: mapState(['finance']),

    methods: {
        onGo() {
            this.$router.push('/product/1');
        },

        handleRead(link) {
            window.open(`/static/pdf/${link}.pdf`);
        }
    }
};
</script>

<style lang="scss" scoped>
.hold {
    .title {
        color: #32302f;
        padding-top: 0.4rem;
        font-family: Noto serif JP;
        font-size: 0.4rem;
        font-weight: 700;
        line-height: 0.52rem;
    }

    .box {
        margin-top: 0.4rem;
        box-sizing: border-box;
        border-radius: 0.16rem;
        padding: 0.4rem 0.6rem;
        position: relative;
        background-image: url("./img/bg-s.png");
        background-size: 100% 100%;

        .box-title {
            font-family: Noto Sans JP;
            font-size: 0.14rem;
            font-weight: 400;
            line-height: 0.22rem;
            color: #f0f0f0;
        }

        .title1 {
            margin-top: 0.16rem;
            margin-bottom: 0.16rem;
            font-family: Noto serif JP;
            font-size: 0.32rem;
            font-weight: 700;
            line-height: 0.42rem;
            color: #fff;
        }

        .title2 {
            font-family: Noto Sans JP;
            font-size: 0.14rem;
            font-weight: 400;
            line-height: 0.22rem;
            color: #fff;
        }

        .info {
            margin-bottom: 0.08rem;
            margin-top: 0.36rem;
            width: 5.2rem;
            padding: 0.28rem 0.4rem;
            border-radius: 0.16rem;
            background-color: #fff;
            border: 1px solid #cacaca;
            display: flex;
            justify-content: space-between;

            .info-item {
                display: flex;
                flex-direction: column;

                .info-title {
                    text-align: center;
                    font-family: Noto Sans JP;
                    font-size: 0.2rem;
                    font-weight: 700;
                    line-height: 0.26rem;
                    color: #32302f;
                }

                .info-desc {
                    margin-top: 0.12rem;
                    text-align: center;
                    color: #828180;
                    font-family: Noto Sans JP;
                    font-size: 0.12rem;
                    font-weight: 400;
                    line-height: 0.19rem;
                }
            }
        }

        .pdf-wrap {
            display: flex;
            align-items: center;
            height: 0.38rem;
            padding: 0.08rem 0;
            margin-top: 0.16rem;

            .pdf-item {
                display: flex;
                align-items: center;
                margin-left: 0.4rem;
                cursor: pointer;

                &:first-child {
                    margin-left: 0;
                }

                .pdf-icon {
                    width: 0.16rem;
                    height: 0.16rem;
                }

                .pdf-title {
                    margin-left: 0.04rem;
                    font-family: Noto Sans JP;
                    font-size: 0.14rem;
                    font-weight: 400;
                    line-height: 0.22rem;
                    color: #f0f0f0;
                }
            }
        }

        .sub-info {
            font-family: Noto Sans JP;
            font-size: 0.12rem;
            font-weight: 400;
            line-height: 0.19rem;
            color: #cacaca;

            &:last-child {
                margin-top: 0.08rem;
            }
        }

        .arrow {
            margin-top: 0.36rem;
            width: 0.48rem;
            height: 0.48rem;
        }
    }
}
</style>
